import type { TimeOfDay } from "./redo-time-picker";

/**
 * Convert a wall-clock date + time-of-day, interpreted in `timezone`, into an
 * absolute `Date` (UTC instant). E.g. June 5 09:00 in "America/Los_Angeles"
 * becomes the corresponding UTC instant.
 */
export function plainDateToDate(
  date: Temporal.PlainDate,
  time: TimeOfDay,
  timezone: string,
): Date {
  return new Date(
    date
      .toPlainDateTime({ hour: time.hours, minute: time.minutes })
      .toZonedDateTime(timezone).epochMilliseconds,
  );
}

/** The wall-clock calendar date of `date` as observed in `timezone`. */
export function dateToPlainDate(
  date: Date,
  timezone: string,
): Temporal.PlainDate {
  return Temporal.Instant.fromEpochMilliseconds(date.getTime())
    .toZonedDateTimeISO(timezone)
    .toPlainDate();
}

/** The wall-clock time-of-day of `date` as observed in `timezone`. */
export function dateToTimeOfDay(date: Date, timezone: string): TimeOfDay {
  const plainTime = Temporal.Instant.fromEpochMilliseconds(date.getTime())
    .toZonedDateTimeISO(timezone)
    .toPlainTime();
  return { hours: plainTime.hour, minutes: plainTime.minute };
}
